<template>
  <v-layout row wrap class="transaction-history-header">
    <!-- <div class="container"> -->
    <v-flex xs1 md1>
      <button class="btn btn-link details-return-btn" @click="back()">
        <v-icon>mdi-arrow-left-bold-circle-outline</v-icon>
      </button>
    </v-flex>
    <v-flex xs4 md4 class="transaction-history-header-info">
      <h3>
        <v-icon>{{
          transaction.payment_method === "credit_card"
            ? "mdi-credit-card"
            : "mdi-barcode"
        }}</v-icon>
        TRANSAÇÃO #{{ transaction.id }}
      </h3>
      <p>
        Efetuada em
        <span class="highlight">{{
          transaction.date_updated | formatDate
        }}</span>
      </p>
    </v-flex>
    <v-flex xs1 md1 class="transaction-history-header-info">
      <span class="separator"></span>
    </v-flex>
    <v-flex xs3 md3 class="transaction-history-header-info">
      <div class="transaction-history-header-info has-partial-capture">
        <h3>
          <span class="light">R$</span
          >{{ (transaction.amount / 100) | formatCurrency }}
        </h3>
        <p>
          Taxa da transação
          <span class="highlight"
            >R$ {{ sumFee(transaction.payables) | formatCurrency }}</span
          >
        </p>
        <p>
          Valor Capturado
          <span class="highlight"
            >R$ {{ (transaction.paid_amount / 100) | formatCurrency }}</span
          >
        </p>
      </div>
    </v-flex>
    <v-flex xs2 md2 class="transaction-history-header-info">
      <div class="transaction-history-header-info detail-status">
        <p>Status da Transação</p>
        <div class="details-status details-transaction-status paid">
          {{ transaction.status | formatTransactionStatus }}
        </div>
      </div>
    </v-flex>

    <!-- </div> -->
  </v-layout>
</template>
<script>
import { GET_TRANSACTION } from "../../graphql/transaction";
import moment from "moment";
import { EventBus } from "../../utils/event-bus";
export default {
  props: ["transaction_id"],
  data: () => ({
    transaction: {},
  }),
  created() {
    // console.log('transaction_id: ', this.transaction_id)
    this.$apollo
      .query({
        // gql query
        query: GET_TRANSACTION,
        // Reactive parameters
        variables: {
          // Use vue reactive properties here
          id: this.transaction_id,
        },
      })
      .then((transaction) => {
        // Seta as faturas no eventBus para o outro Componente
        this.transaction = transaction.data.transaction;
        EventBus.$emit("transaction", this.transaction);
      })
      .catch((error) => {
        console.error("Erro ao capturar histórico de Transação. ", error);
      });
  },
  beforeDestroy() {
    //do something before destroying vue instance
    // EventBus.$off('transaction')
  },
  methods: {
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
  },
  filters: {
    // transactionTitle: function(value){
    //     if(value === 'capture') return 'CAPTURA'
    //     else if(value === 'authorize') return 'AUTORIZAÇÃO'
    //     else if(value === 'refund') return 'ESTORNO'
    //     else if(value === 'issue') return 'BOLETO EMITIDO'
    //     else if(value === 'conciliate') return 'Conciliate'
    //     else return value
    // },
    // msToTime: function(duration) {
    //     var // milliseconds = parseInt((duration%1000)/100),
    //         seconds = parseInt((duration/1000)%60),
    //         minutes = parseInt((duration/(1000*60))%60),
    //         hours = parseInt((duration/(1000*60*60))%24);

    //     hours = (hours < 10) ? "0" + hours : hours;
    //     minutes = (minutes < 10) ? "0" + minutes : minutes;
    //     seconds = (seconds < 10) ? "0" + seconds : seconds;

    //     return hours + ":" + minutes + ":" + seconds // + "." + milliseconds.toFixed(0);
    // },
    // msToDate: function(duration) {
    //     if(duration === '' || duration === 'null') return ''
    //     else return moment(parseInt(duration)).format("DD/MM/YYYY HH:mm:ss")
    // },
    formatDate: function (date) {
      if (date === "" || date === "null") return "";
      else return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    // transactionResponse: function(code) {
    //     if(code === '' || code === 'null') return ''
    //     else if(code === '0') return 'Transação autorizada'
    //     else if(code === '1000') return 'Transação não autorizada'
    //     else return code
    // },
    // transactionColor: function(status) {
    //     if(status === '' || status === 'null') return 'green'
    //     else if(status === 'success') return 'blue'
    //     else return 'red'
    // }
  },
};
</script>
<style scoped>
.transaction-history-header {
  height: auto;
  min-height: 105px;
  background-color: #f6f6f5;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 5px;
}
.transaction-history-header .container {
  padding: 0px;
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.transaction-history-header-info {
  color: #9c9c9b;
  margin-left: 10px;
  margin-right: 10px;
}

.details-return-btn {
  margin-top: 31.5px;
  margin-bottom: 31.5px;
  color: #767676;
  font-size: 20px;
  outline: none !important;
}

.pull-left {
  float: left !important;
}

.transaction-history-header-info > h3 {
  font-size: 23px;
  font-weight: 600;
  margin: 0;
}

.transaction-history-header-info > p {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 5px;
}
p {
  margin: 0 0 11px;
}

.transaction-history-header-info .highlight {
  color: #999999;
  font-weight: 600;
}

.transaction-history-header .separator {
  border-right: 1px solid #e6e6e6;
  padding: 0px 0 70px 0;
}

.transaction-history-header-info.has-partial-capture {
  /* margin-top: 20px; */
}

.transaction-history-header-info.detail-status {
  /* margin-left: 35px; */
}
.details-status.paid {
  background-color: #3cb880;
}
.details-status {
  height: 25px;
  color: #fff;
  line-height: 25px;
  padding: 0 10px;
  font-size: 15px;
  margin-top: 4px;
  font-weight: 600;
  border-radius: 3px;
  display: inline-block;
}
</style>
